export const baseSize = 300;

export const getSize: (size?: string) => number = (size = "0") => {
  return baseSize + Number(size) * 20;
};
